import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  TextField,
  FormControl,
  Divider,
  Modal,
  Fade,
  Backdrop,
} from "@mui/material";
import { Visibility, Edit, Delete, Opacity } from "@mui/icons-material";
import Link from "@mui/material/Link";
import ReportIcon from "../../../../Image/report.png";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { TablePagination } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import Container from "@mui/material/Container";
import CompletedIcon from "../../../../Image/completeicon.png";
import PendingIcon from "../../../../Image/pendingicon.png";
import CancelledIcon from "../../../../Image/cancelicon.png";
import AllIcon from "../../../../Image/allmedicalicon.png";
import dayjs from "dayjs";
import axios from "axios";
import { APIEndpoint } from "../../../../client/apiconfig";
import { BasicAuthUser } from "../../../../client/basicAuth";

// Remove unused imports if not used elsewhere
// import { Dayjs } from "dayjs";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  borderRadius: "20px",
  border: "1px solid #E6E6E6",
  width: "60%",
  [theme.breakpoints.up("sm")]: {
    marginRight: theme.spacing(0),
    width: "40ch",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  right: 0,
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#B1B1B1",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(0)})`,
    paddingRight: `calc(1em + ${theme.spacing(2)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "100ch",
      "&:focus": {
        width: "100ch",
      },
    },
  },
}));

type DocumentStatus = "ทั้งหมด" | "เสร็จสิ้น" | "รอดำเนินการ" | "ยกเลิก";

interface Document {
  sequence: number;
  document_id: string;
  person_name: string;
  staff_name: string;
  verifiable_credential_type: string;
  person_type: string;
  verifiable_credential_status: string;
  created_at: string;
}

interface DeleteDocuments {
  account_id: string;
  document_id: string;
}

const DocumentPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<DocumentStatus>("ทั้งหมด");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [dataReport, setDataReport] = useState<Document[]>([]); // กำหนดค่าเริ่มต้นเป็น array
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [base64Data, setBase64Data] = useState<string | null>(null);

  const handleButtonClick = (tab: DocumentStatus) => {
    setSelectedTab(tab);
  };

  // const username = process.env.REACT_APP_BASIC_AUTH_USERNAME;
  //   const password = process.env.REACT_APP_BASIC_AUTH_PASSWORD;

  //   if (!username || !password) {
  //     throw new Error("Basic Auth env variables are missing");
  //   }

  //   const BasicAuthUser = {
  //     username,
  //     password,
  //   };

  const fetchDataReport = async () => {
    const storedDataPerson = sessionStorage.getItem("Data");
    // ตรวจสอบว่ามีข้อมูลใน localStorage หรือไม่
    if (storedDataPerson) {
      const parsedDataPerson = JSON.parse(storedDataPerson);
      const accountID = parsedDataPerson?.result?.data?.account_id;

      // console.log("accountID", accountID);

      // ตรวจสอบว่า accountID มีค่าและไม่ใช่ undefined หรือ null
      if (accountID) {
        try {
          // ใช้ accountID ต่อท้ายใน URL อย่างถูกต้อง
          const response = await axios.get(
            `${APIEndpoint.GetStatusAll}?account_id=${accountID}`,
            {
              auth: BasicAuthUser, // ส่ง authentication ไปกับ request
            }
          );
          setDataReport(response.data.result);
          // console.log("response", response.data.result);
        } catch (error) {
          console.error("Error fetching data report:", error);
        }
      } else {
        console.error("No account ID found.");
      }
    } else {
      console.error("No stored data found in localStorage.");
    }
  };
  const handleDeleteDocument = async (document_id: string) => {
    const storedDataPerson = sessionStorage.getItem("Data");
    if (storedDataPerson) {
      const parsedDataPerson = JSON.parse(storedDataPerson);
      const account_id = parsedDataPerson?.result?.data?.account_id;

      if (account_id) {
        try {
          const deleteData: DeleteDocuments = {
            document_id,
            account_id, // เพิ่ม account_id แทนที่ provider_access_token
          };

          const response = await axios.post(
            `${APIEndpoint.DeleteDocument}`, // เพิ่ม endpoint ที่จะใช้ลบเอกสาร
            deleteData,
            {
              auth: BasicAuthUser,
            }
          );

          if (response.data.status_result.status_message_code === 200) {
            // console.log("Document deleted successfully:", response.data);
            // ลบเอกสารออกจาก dataReport โดยใช้ filter
            setDataReport((prevData) =>
              prevData.filter((doc) => doc.document_id !== document_id)
            );
            window.location.href = "/e-digitalcert";
          } else if (response.data.status_result.status_message_code === 500) {
            console.error("Error: Not found data for the profile of person.");
          } else {
            console.error(
              response.data.status_result.status_message_code
            );
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  const rows: Document[] = dataReport || [];

  // validate staff_name here if it available, add it to the table
  // else, add a doctor name + role as a default value
  rows.forEach((row) => {
    if (!row.staff_name) {
      // หมายความว่าหมอออกเอกสารเอง เพราะงั้นเลยใส่ชื่อหมอและตำแหน่งเข้าไปจะได้เข้าใจได้ง่าย ๆ ว่าหมอออกเอกสารเอง
      row.staff_name = `${row.person_name} (${row.person_type})`;
    }
  });

  // console.log("rows:", rows);

  const filteredRows = rows
    .filter(
      (row) =>
        selectedTab === "ทั้งหมด" ||
        row.verifiable_credential_status === selectedTab
    )
    .filter(
      (row) =>
        selectedTab === "ทั้งหมด" ||
        row.verifiable_credential_status === selectedTab
    )
    .filter((row) => {
      // แปลงวันที่ในข้อมูลให้อยู่ในรูปแบบเดียวกับ DatePicker
      const formattedRowDate = dayjs(row.created_at, "DD/MM/YYYY");

      // ถ้า selectedDate ถูกเลือก จะทำการกรองตามวันที่, ถ้าไม่ได้เลือกก็จะไม่กรอง
      const isDateMatch = selectedDate
        ? formattedRowDate.isSame(selectedDate, "day")
        : true;

      // กรองข้อมูลตามวันที่ที่เลือกและเงื่อนไขการค้นหาอื่น ๆ
      return (
        isDateMatch &&
        (row.document_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.verifiable_credential_type
            .toLowerCase()
            .includes(searchQuery.toLowerCase()))
      );
    });

  const handleSearch = () => {
    // ใช้ searchInput สำหรับค้นหาตามเลขที่เอกสารหรือประเภท
    setSearchQuery(searchInput.trim());

    // ถ้าค้นหาด้วยวันที่ ให้ setDate ที่เลือก
    if (selectedDate) {
      setSelectedDate(selectedDate);
    } else {
      // ถ้าไม่ได้เลือกวันที่ ให้ไม่ทำการค้นหา
      return;
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const rowsPerPageOptions = [10, 25, 50, 100];

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    setSearchInput(value);
    if (value === "") {
      setSearchQuery("");
    }
  };

  const editPdf = (row: Document) => async () => {
    // console.log("selected row:", row);
    try {
      const response = await axios.get(
        `${APIEndpoint.GetMedCertDataByDocID}${row.document_id}`,
        {
          auth: BasicAuthUser,
        }
      );
      // set to edit mode
      // console.log("fetching data report: ", response.data.result);
      // console.log("doc mode is edit");
      sessionStorage.setItem("docMode", "edit");
      sessionStorage.setItem("document", JSON.stringify(response.data.result));
      // window.open("/e-medicalcert");
      window.location.href = "/e-medicalcert";
    } catch (error) {
      console.error("Error fetching data report:", error);
    }

    // sessionStorage.setItem("document", JSON.stringify(row));
    // window.open("/e-medicalcert");
  };

  useEffect(() => {
    setPage(0);
    fetchDataReport();
  }, [searchQuery]);

  const getBase64Data = async (documentId: string) => {
    const rawData = sessionStorage.getItem("Data");
    if (!rawData) {
      console.error("No data found in localStorage.");
      return;
    }
    const data = JSON.parse(rawData);
    const accountIDPerson = data?.result?.data?.account_id;

    let resultAccountID = ""; // ประกาศตัวแปรนอก if เพื่อให้ใช้ได้ในทุก scope

    if (accountIDPerson) {
      // ถ้ามีค่าใน localStorage ให้ลบเครื่องหมายคำพูด
      resultAccountID = accountIDPerson.replace(/"/g, "");
    } else {
      // console.log("account_id ไม่พบใน localStorage หรือเป็น null");
      return; // หยุดการทำงานถ้าไม่มี account_id
    }

    try {
      const response = await axios.post(
        APIEndpoint.GetBase64,
        {
          document_id: documentId,
          account_id: resultAccountID, // ใช้ resultAccountID ที่กำหนดค่าไว้แล้ว
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          auth: BasicAuthUser,
        }
      );

      // console.log('ResponseBase64:', response.data.result[0].pdf_data);
      setBase64Data(response.data.result[0].pdf_data);
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };
  // console.log("Display Rows:", rows);

  const modalPDFStyle = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    height: 600,
    bgcolor: "background.black",
    boxShadow: 24,
    p: 1,
  };

  return (
    <Box sx={{ m: 4, p: 3 }}>
      {/* Header */}
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={{ color: "#2F4491" }}>
          ใบรับรองอิเล็กทรอนิกส์
        </Typography>

        <Link href="/e-medicalcert" underline="none">
          <Button
            onClick={() => {
              // reset doc mode to create if it's not in create mode
              const getDocMode = sessionStorage.getItem("docMode");
              if (getDocMode) {
                if (getDocMode !== "create") {
                  sessionStorage.removeItem("authorizeForm");
                  sessionStorage.removeItem("patientForm");
                  sessionStorage.removeItem("patientDate");
                  sessionStorage.removeItem("diagnosticForm");
                  // set it to create mode
                  sessionStorage.setItem("docMode", "create");
                  // log
                  // console.log("reset docMode to create");
                } else {
                  // console.log("docMode is create");
                }
                // href to e-medicalcert by no new tab
                // window.open("/e-medicalcert");
              }
            }}
            variant="outlined"
            sx={{
              borderRadius: 20,
              borderColor: "#2F4491",
              color: "#2F4491",
              fontFamily: "Sarabun, sans-serif",
            }}
            startIcon={
              <img
                src={ReportIcon}
                alt="icon"
                style={{ width: 20, height: 20, textAlign: "center" }}
              />
            }
          >
            ออกใบรับรองอิเล็กทรอนิกส์
          </Button>
        </Link>
      </Grid>

      {/* Custom Buttons as Tabs */}
      <Box
        sx={{
          display: "flex",
          my: 2,
          justifyContent: "center", // Center the buttons within the container
          position: "sticky", // Keep the buttons in a fixed position when scrolling
          top: 0, // Adjust based on the top of the viewport
          zIndex: 1, // Ensure it appears on top of other content
        }}
      >
        {(["ทั้งหมด", "เสร็จสิ้น", "รอดำเนินการ", "ยกเลิก"] as const).map(
          (tab) => {
            const count =
              tab === "ทั้งหมด"
                ? rows.length
                : rows.filter((row) => row.verifiable_credential_status === tab)
                    .length;

            const isSelected = selectedTab === tab;
            const baseColor = "#dedede";

            const tabConfig = {
              เสร็จสิ้น: {
                color: "#18A14C",
                hover: "#8adba9",
                icon: CompletedIcon,
              },
              รอดำเนินการ: {
                color: "#F49E0B",
                hover: "#f2c373",
                icon: PendingIcon,
              },
              ยกเลิก: {
                color: "#EE4444",
                hover: "#fe8484",
                icon: CancelledIcon,
              },
              ทั้งหมด: { color: "#2F4491", hover: "#D8ECF5", icon: AllIcon },
            } as const;

            const { color, hover, icon } = tabConfig[tab];

            return (
              <Button
                key={tab}
                onClick={() => handleButtonClick(tab as DocumentStatus)}
                sx={{
                  mr: 1,
                  px: 3,
                  py: 1,
                  fontSize: "16px",
                  borderRadius: "15px",
                  height: "60px",
                  width: "100%",
                  maxWidth: "400px",
                  padding: "10px",
                  whiteSpace: { xs: "normal", lg: "nowrap" },
                  backgroundColor: isSelected ? color : baseColor,
                  color: isSelected ? "#fff" : "#2F4491",
                  textTransform: "uppercase",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    backgroundColor: isSelected ? color : hover,
                    transform: "translateY(-3px)",
                  },
                  "&:active": {
                    boxShadow: "none",
                    transform: "scale(0.98)",
                  },
                }}
              >
                <img
                  src={icon}
                  alt={tab}
                  width={65}
                  height={120}
                  style={{ marginRight: "2px" }}
                />
                {tab} ({count})
              </Button>
            );
          }
        )}
      </Box>
      <Grid
        sx={{
          p: 3,
          background: "#ffffff",
          borderRadius: "15px",
        }}
      >
        {/* Search Box and Date Picker */}
        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={12} lg={6}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                sx={{
                  mr: 1,
                  fontFamily: "Sarabun, sans-serif",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                }}
              >
                เลือกวันที่ต้องการ:
              </Typography>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    format="DD/MM/YYYY"
                    slots={{
                      textField: TextField,
                      actionBar: () => (
                        <>
                          <Divider sx={{ my: 1 }} />
                          <Box
                            display="flex"
                            justifyContent="flex-end"
                            padding="10px"
                          >
                            <Button
                              onClick={() => setSelectedDate(null)}
                              color="error"
                            >
                              ล้าง
                            </Button>
                          </Box>
                        </>
                      ),
                    }}
                    slotProps={{
                      textField: {
                        name: "selectedDate",
                        InputLabelProps: { shrink: true },
                        sx: {
                          width: {
                            xs: "500px",
                            sm: "500px",
                            md: "700px",
                            lg: "65%",
                            xl: "500px",
                          },
                          minWidth: { lg: "65%" },
                          maxWidth: { lg: "65%" },
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "20px",
                            height: "40px",
                            padding: "0 12px",
                            fontSize: "14px",
                            fontFamily: "Sarabun, sans-serif",
                          },
                          "& .Mui-selected": {
                            color: "#FFFFFF",
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12} lg={6}>
            <Box
              sx={{
                gap: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: {
                  xs: "flex-start",
                  lg: "flex-end",
                },
              }}
            >
              <Search
                sx={{
                  width: {
                    xs: "500px",
                    sm: "510px",
                    md: "710px",
                    lg: "107%",
                    xl: "100%",
                  },
                  minWidth: { lg: "107%" },
                  maxWidth: { lg: "107%" },
                  borderRadius: "20px",
                  height: "40px",
                }}
              >
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  name="search"
                  sx={{
                    fontSize: "14px",
                    padding: "0 12px",
                    fontFamily: "Sarabun, sans-serif",
                  }}
                  placeholder="ค้นหาเลขที่เอกสาร /ประเภทใบรับรองแพทย์"
                  inputProps={{ "aria-label": "search" }}
                  value={searchInput}
                  onChange={handleSearchInputChange}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") handleSearch();
                  }}
                />
              </Search>

              <Button
                onClick={handleSearch}
                variant="contained"
                sx={{
                  backgroundColor: "#2F4491",
                  color: "#fff",
                  borderRadius: "20px",
                  width: 80,
                  minWidth: 80,
                  maxWidth: 80,
                  height: "40px",
                  fontSize: "14px",
                  fontFamily: "Sarabun, sans-serif",
                  "&:hover": {
                    backgroundColor: "#2F4491",
                  },
                }}
              >
                ค้นหา
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Table */}
        <TableContainer>
          <Table
            sx={{ minWidth: 550 }}
            aria-label="simple table"
            className="table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#ECF5FF" }}>
                <TableCell sx={{ textAlign: "center" }}>ลำดับ</TableCell>
                <TableCell sx={{ textAlign: "left" }}>เลขที่เอกสาร</TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  ประเภทใบรับรองแพทย์
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  เจ้าหน้าที่ออกเอกสาร
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  วันที่สร้างเอกสาร
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>สถานะ</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="table_body">
              {filteredRows.length > 0 ? (
                filteredRows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={row.sequence}>
                      {/* ลำดับ */}
                      <TableCell sx={{ textAlign: "center" }}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      {/* เลขที่เอกสาร */}
                      <TableCell
                        sx={{
                          textAlign: "left",
                          wordBreak: "break-word",
                          wordWrap: "break-word",
                        }}
                      >
                        {row.document_id}
                      </TableCell>
                      {/* ประเภทใบรับรองแพทย์ */}
                      <TableCell
                        sx={{
                          textAlign: "left",
                        }}
                      >
                        {row.verifiable_credential_type}
                      </TableCell>
                      {/* เจ้าหน้าที่ออกเอกสาร */}
                      <TableCell
                        sx={{
                          textAlign: "center",
                          wordBreak: "break-word",
                          wordWrap: "break-word",
                        }}
                      >
                        {row.staff_name}
                      </TableCell>
                      {/* วันที่สร้างเอกสาร */}
                      <TableCell
                        sx={{
                          color: "#587889",
                          textAlign: "center",
                          wordBreak: "break-word",
                          wordWrap: "break-word",
                        }}
                      >
                        {row.created_at}
                      </TableCell>
                      {/* สถานะ */}
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              color:
                                row.verifiable_credential_status === "เสร็จสิ้น"
                                  ? "#18A14C"
                                  : row.verifiable_credential_status ===
                                    "รอดำเนินการ"
                                  ? "#F49E0B"
                                  : "#EE4444",
                              backgroundColor:
                                row.verifiable_credential_status === "เสร็จสิ้น"
                                  ? "#F7FDF9"
                                  : row.verifiable_credential_status ===
                                    "รอดำเนินการ"
                                  ? "#FFFAF5"
                                  : row.verifiable_credential_status ===
                                    "ยกเลิก"
                                  ? "#FFF5F5"
                                  : "#9E9E9E",
                              fontSize: "14px",
                              borderRadius: "10px",
                              whiteSpace: "nowrap",
                              padding: "4px 8px",
                              display: "inline-block",
                            }}
                          >
                            {row.verifiable_credential_status}
                          </Typography>
                        </Box>
                      </TableCell>
                      {/* Action */}
                      <TableCell
                        sx={{
                          textAlign: "center",
                          whiteSpace: { md: "nowrap" },
                        }}
                      >
                        {row.verifiable_credential_status !== "รอดำเนินการ" && (
                          <IconButton
                            sx={{ color: "#2F4491" }}
                            onClick={() => {
                              handleOpen();
                              getBase64Data(row.document_id);
                            }}
                          >
                            <Visibility />
                          </IconButton>
                        )}
                        {row.verifiable_credential_status !== "ยกเลิก" && (
                          <IconButton
                            sx={{ color: "#212529" }}
                            onClick={editPdf(row)}
                          >
                            <Edit />
                          </IconButton>
                        )}
                        <IconButton
                          color="error"
                          onClick={() => handleDeleteDocument(row.document_id)}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    - ไม่พบข้อมูล -
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          SelectProps={{
            inputProps: {
              name: "rowsPerPage",
            },
          }}
        />
      </Grid>
      {/* Template for pdf */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={modalPDFStyle}>
            {/* PDF HERE */}
            <embed
              src={`data:application/pdf;base64,${base64Data}`}
              type="application/pdf"
              width="100%"
              height="100%"
            />
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default DocumentPage;
